import { connect } from 'react-redux';
import SearchBar from '../components/search-bar';
import { clearSearch, getSearchFilters, shouldRefetch } from './search-actions';

const mapStateToProps = state => ({
  searchValue: state.search.searchValue,
  searchFilters: state.search.searchFilters,
  isLoadingFilters: state.search.isLoadingFilters,
});

const mapDispatchToProps = {
  clearInput: clearSearch,
  getSearchFilters,
  shouldRefetch,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchBar);
